import { Party } from '@scts/models';
import AddressComponent from './address';
import Basic from './basic';

export interface ClientProps {
  client: Party;
}

const Client = (clientProps: ClientProps) => {
  return (
    <div className="d-flex flex-column flex-lg-row flex-wrap">
      <Basic basicDetails={clientProps.client} />

      <AddressComponent address={clientProps.client.address} />
    </div>
  );
};

export default Client;
